<template>
  <div>
    <Head :title="course.name" />

    <Dialog
      v-model:visible="modalNewChapter"
      modal
      header="
        Create Chapter
      "
      pt:header:class="bg-gray-100 rounded-t-lg py-2"
      :draggable="false"
      maximizable
      @close="modalNewChapter = false"
    >
      <new-chapter
        :course="courseData"
        @success="
          modalNewChapter = false;
          reloadData();
        "
      />
    </Dialog>
    <Dialog
      v-model:visible="modalEditChapter"
      modal
      header="
        Edit Chapter
      "
      pt:header:class="bg-gray-100 rounded-t-lg py-2"
      :draggable="false"
      maximizable
      @close="modalEditChapter = false"
    >
      <edit-chapter
        :course="courseData"
        :chapter="chapterToEdit"
        @success="
          modalEditChapter = false;
          reloadData();
        "
      />
    </Dialog>
    <Dialog
      v-model:visible="modalNewSubject"
      modal
      :header="
        'Creaza subiect pt capitolul \'' + chapterForSubject?.name + '\''
      "
      pt:header:class="bg-gray-100 rounded-t-lg py-2"
      :draggable="false"
      maximizable
      @close="
        modalNewSubject = false;
        chapterForSubject = null;
      "
    >
      <new-subject
        :chapter="chapterForSubject"
        @success="
          modalNewSubject = false;
          chapterForSubject = null;
          reloadData();
        "
      />
    </Dialog>
    <Dialog
      v-model:visible="modalEditSubject"
      modal
      header="Edit Subject"
      pt:header:class="bg-gray-100 rounded-t-lg py-2"
      :draggable="false"
      maximizable
      @close="
        modalEditSubject = false;
        chapterForSubject = null;
      "
    >
      <edit-subject
        :subject="subjectToEdit"
        :chapter="chapterForSubject"
        @success="
          modalEditSubject = false;
          chapterForSubject = null;
          reloadData();
        "
      />
    </Dialog>

    <div class="mb-4 flex max-w-3xl justify-start flex-row">
      <h1 class="text-3xl font-bold mr-5">
        <Link
          class="text-indigo-500 hover:text-indigo-600"
          :href="$routes.courses()"
        >
          Cursuri
        </Link>
        <span class="font-medium text-indigo-400">/</span>
        {{ courseData.name }}
      </h1>
      <div class="flex items-center">
        <Link class="btn-teal" :href="$routes.edit_course(course.id)">
          Editeaza date curs
        </Link>
      </div>
    </div>
    <div class="shadow-sm bg-white rounded-sm w-fit flex items-center">
      <span class="p-2"
        ><span class="font-bold">Nume:</span> {{ courseData.name }}</span
      >
      <span class="p-2"
        ><span class="font-bold">Tip:</span> {{ courseData.type }}</span
      >
      <i
        class="pi pi-image p-2 text-2xl"
        :class="courseData.existing_image ? 'text-green-500' : 'text-red-500'"
      ></i>
    </div>
    <div class="flex flex-row mb-1 mt-8">
      <h1 class="text-3xl font-bold">Capitole</h1>
      <button class="btn-teal ml-5" @click="modalNewChapter = true">
        Adauga capitol nou
      </button>
    </div>
    <div class="mt-4 overflow-y-auto" scroll-region="">
      <div class="w-lg">
        <template
          v-for="(chapter_id, indexC) in courseData.ordered_chapter_ids"
          :key="chapter_id"
        >
          <div class="rounded-md w-full flex flex-row mt-3">
            <div class="w-8 item-numbering">
              {{ indexC + 1 + ' ' }}
            </div>
            <div class="py-2 item-rest">
              {{ chapters[chapter_id].name }}
              <div class="flex flex-row">
                <button
                  class="btn-teal btn-small"
                  @click="
                    modalNewSubject = true;
                    chapterForSubject = chapters[chapter_id];
                  "
                >
                  +
                </button>
                <button
                  class="btn-teal btn-small ml-2"
                  @click="
                    modalEditChapter = true;
                    chapterToEdit = chapters[chapter_id];
                  "
                >
                  Edit
                </button>
                <button
                  class="btn-red btn-small ml-2"
                  @click="destroyChapter(chapter_id)"
                >
                  X
                </button>
              </div>
            </div>
          </div>
          <div
            v-for="(subject_id, indexS) in chapters[chapter_id]
              .ordered_subjects_ids"
            :key="subject_id"
            class="rounded-md w-full flex flex-row mt-3 ml-10"
          >
            <div class="w-11 item-numbering">
              {{ indexC + 1 + '.' + (indexS + 1) + ' ' }}
            </div>
            <div class="py-1 item-rest">
              {{ subjects[subject_id].name }}
              <div class="flex">
                <div
                  v-if="subjects[subject_id].type === 'VideoSubject'"
                  v-tooltip.top="{
                    value: subjects[subject_id].existing_video
                      ? subjects[subject_id].hls_processed
                        ? 'Video procesat'
                        : 'Video in curs de procesare'
                      : 'Lipseste video',
                  }"
                >
                  <icon
                    v-if="subjects[subject_id].existing_video"
                    name="video"
                    class="h-8"
                    :class="
                      subjects[subject_id].hls_processed
                        ? 'stroke-black'
                        : 'stroke-yellow-400'
                    "
                  />
                  <icon v-else name="no-video" class="stroke-red-400 h-8" />
                </div>
                <div
                  v-if="subjects[subject_id].type === 'DocumentsSubject'"
                  class="h-8 text-2xl flex flex-row items-center"
                  :class="{
                    'text-red-400': !has_files(subjects[subject_id]),
                  }"
                >
                  {{
                    has_files(subjects[subject_id])
                      ? Object.keys(subjects[subject_id].existing_documents)
                          .length
                      : 0
                  }}<i class="ml-0.5 pi pi-file text-xl"></i>
                </div>
                <div
                  v-if="subjects[subject_id].type === 'QuizSubject'"
                  class="h-8 text-2xl flex flex-row items-center"
                  :class="{
                    'text-red-400':
                      !subjects[subject_id].quiz_questions ||
                      subjects[subject_id].quiz_questions.length === 0,
                  }"
                >
                  {{
                    subjects[subject_id].quiz_questions
                      ? subjects[subject_id].quiz_questions.length
                      : 0
                  }}<i class="ml-0.5 pi pi-question-circle text-xl"></i>
                </div>
                <button
                  class="btn-teal btn-small ml-2"
                  @click="
                    modalEditSubject = true;
                    subjectToEdit = subjects[subject_id];
                    chapterForSubject = chapters[chapter_id];
                  "
                >
                  Edit
                </button>
                <button
                  class="btn-red btn-small ml-2"
                  @click="destroySubject(subject_id)"
                >
                  X
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import NewChapter from '@/Pages/Chapters/_New.vue';
import EditChapter from '@/Pages/Chapters/_Edit.vue';
import NewSubject from '@/Pages/Subjects/_New.vue';
import EditSubject from '@/Pages/Subjects/_Edit.vue';
import Icon from '@/Shared/Icon.vue';
import Dialog from 'primevue/dialog';
import axios from 'axios';

export default {
  components: {
    Head,
    Link,
    NewChapter,
    EditChapter,
    NewSubject,
    EditSubject,
    Icon,
    Dialog,
  },
  layout: Layout,
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      courseData: this.course,
      chapters: this.course.chapters,
      subjects: this.course.subjects,

      modalNewChapter: false,
      modalEditChapter: false,
      chapterToEdit: null,
      chapterForSubject: null,
      modalNewSubject: false,
      modalEditSubject: false,
      subjectToEdit: null,
    };
  },

  methods: {
    async destroyChapter(chapterId) {
      if (
        confirm(
          'Esti sigur(a) ca vrei sa stergi acest capitol? Toate subiectele asociate vor fi sterse de asemenea',
        )
      ) {
        try {
          await axios.delete(this.$routes.chapter(chapterId), {
            params: { format: 'json' },
          });
          this.reloadData();
        } catch (err) {
          console.log(err);
        }
      }
    },

    async destroySubject(subjectId) {
      if (confirm('Esti sigur(a) ca vrei sa stergi acest subiect?')) {
        try {
          await axios.delete(this.$routes.subject(subjectId), {
            params: { format: 'json' },
          });
          this.reloadData();
        } catch (err) {
          console.log(err);
        }
      }
    },

    async reloadData() {
      try {
        let response = await axios.get(this.$routes.course(this.course.id), {
          params: { format: 'json' },
        });
        let c = response.data.course;
        this.courseData = c;
        this.chapters = c.chapters;
        this.subjects = c.subjects;
      } catch (err) {
        console.log(err);
      }
    },

    has_files(subject) {
      return (
        subject.existing_documents &&
        Object.keys(subject.existing_documents).length > 0
      );
    },
    // TODO: Understand below
    // submit() {
    //   this.form.put(this.$routes.course(this.course.id), {
    //     onSuccess: () => this.form.reset('password', 'photo'),
    //   });
    // },
    // uploadPhoto() {
    //   this.fileForm.post(this.$routes.add_file_chapter(this.selectedChapter.id), {
    //     onSuccess: () => this.fileForm.reset('file'),
    //   })
    // },
    // destroy() {
    //   if (confirm('Are you sure you want to delete this course?')) {
    //     this.$inertia.delete(this.$routes.course(this.course.id));
    //   }
    // },
    // restore() {
    //   if (confirm('Are you sure you want to restore this course?')) {
    //     this.$inertia.put(this.$routes.restore_course(this.course.id));
    //   }
    // },
  },
};
</script>

<style>
@reference "tailwindcss";

.item-numbering {
  @apply bg-teal-700 text-white flex items-center justify-center rounded-l-md font-bold;
}

.item-rest {
  @apply w-full px-1.5 bg-white flex flex-row justify-between items-center hover:bg-amber-50 rounded-r-md text-lg;
}
</style>
